import React from 'react';
import styled from 'styled-components';
import {
  loadingGifV6,
  maxTablet,
  midWidthApp,
  primaryColor, primaryFont, scrollbar, secondaryFont, wMBold, wMedium,
  xxsmMobile,
} from 'Utils/utilsStyle';
import { useSelector } from 'react-redux';
import {
  selectArticleSummary, selectArticleSummaryLoading,
  selectSimilarArticleSummary, selectSimilarArticleSummaryLoading,
} from 'Selector/ArticleSector';
import classNames from 'classnames';
import GilroySmilyFace from '../assets/svgIcons/GilroySmilyFace';

const StyledWrapper = styled.div`
&.marginTopNoImage {
  margin-top: 40px;
}
&.showAllTop {
  margin-bottom: 19px;
}
height: 232px;
border-radius: 8px;
border: 1px solid #DADADA;
background: #F8F8F8;
padding: 12px 4px 12px 12px;
.summary-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  .gilroy-smily-face {
    width: 22px;
    min-width: 23px;
    height: 19px;
    margin-bottom: 3px;;
  }
  .header-text {
    color: #667982;
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: ${wMedium};
    line-height: 22px;
    letter-spacing: -0.438px;
    margin-bottom: 0px;
    margin-left: 8px;
  }
  .show-insights-button {
    background-color: ${primaryColor};
    border: 2px solid ${primaryColor};
    height: 30px;
    border-radius: 6px;
    padding: 7px 16px;
    font-family: ${primaryFont};
    color: #fff;
    font-weight: ${wMedium};
    font-size: 16px;
    cursor: pointer;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    @media all and (max-width: ${midWidthApp}){
      padding: 2px 13px;
      font-size: 12px;
      line-height: normal;
      height: 22px;
      display: flex;
    }
    @media all and (max-width: ${xxsmMobile}){
      padding: 10px 2px;
      font-size: 10px;
      line-height: normal;
      height: 23px;
      display: flex;
    }
  }
}
.loader-div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  .img-loader-popup {
    height: 140px;
    width: 140px;
  }
}
.summary-points-div {
  padding-left: 28px;
  height: calc(100% - 25px);
  ${scrollbar};
  border-radius: 0px !important;
  padding-right: 12px;
  li {
    ::marker {
      border-radius: 10px;
      color: rgb(102, 121, 130);
      font-size: 20px;
    }
    color: #0D0D0D;
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    line-height: 16px;
    letter-spacing: -0.311px;
    margin-bottom: 15px;
  }
}
`;

type Props = {
  isSimilarArticle: boolean
  showAll: boolean
  withOutImage: boolean
  showInsights: boolean
  toggleInsights: () => void
};
const ArticleSummaryBlock = function ArticleSummaryBlock(props: Props) {
  const { isSimilarArticle, showAll, withOutImage, showInsights, toggleInsights } = props;
  const fisrtLoading = useSelector(selectArticleSummaryLoading);
  const similarLoading = useSelector(selectSimilarArticleSummaryLoading);
  const firstArticleSummary = useSelector(selectArticleSummary);
  const similarticleSummary = useSelector(selectSimilarArticleSummary);

  const loading = isSimilarArticle ? similarLoading : fisrtLoading;
  const articleSummary = isSimilarArticle ? similarticleSummary : firstArticleSummary;

  return (
    <StyledWrapper className={classNames(
      { showAllTop: showAll, marginTopNoImage: withOutImage },
    )}
    >
      <div className="summary-header">
        <h4 className="header-text">Gilroy Summary</h4>
      </div>
      {loading ? (
        <div className="loader-div">
          <img className="img-loader-popup" src={loadingGifV6} alt="img-marketing" />
        </div>
      ) : (
        <ul className="summary-points-div">
          {articleSummary?.map((point) => <li>{point}</li>)}
        </ul>
      )}
    </StyledWrapper>
  );
};

export default ArticleSummaryBlock;
